var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.close),expression:"close"}]},[_c('div',{ref:"dropParent",on:{"click":function($event){_vm.visible = !_vm.visible}}},[_vm._t("default")],2),_c('pop',{attrs:{"placement":_vm.placement}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }